import { addDays } from 'date-fns';
import { RestaurantAnimationDto } from '../api';
import { GetAnimationsResult } from '../api/models/get-animations-result';
import { AppErrorKeys } from '../errors/error';
import { getErrorResponse } from './common';

function createAnimation(
  title: string,
  description: string,
  shortDescription: string,
  imageUrl: string,
  pictogramUrl: string | undefined,
  backgroundColor: string | undefined,
  fontColor: string | undefined,
  restaurantLibelle: string,
  startsAt: Date,
  endsAt: Date,
  id: number,
  showPeriode: boolean,
) {
  const animation: RestaurantAnimationDto = {
    id,
    description,
    startsAt: startsAt.toString(),
    endsAt: endsAt.toString(),
    linkLabel: "Plus d'informations",
    linkUrl: '',
    shortDescription,
    title,
    imageUrl,
    pictogramUrl,
    backgroundColor,
    fontColor,
    restaurantLibelle,
    showPeriode,
  };
  return animation;
}

const PROPS = [
  {
    title: 'Semaine Américaine, le Wonderfood',
    description: 'Un ensemble de spécialités américaines vous sera proposé au sein de votre restaurant. Vous pourrez les déguster sous forme de buffet.',
    shortDescription: 'Retrouvons-nous pour voyager en Amérique et profiter de sa cuisine.',
    imageUrl: '../../../../assets-proxy/animations/animation1.png',
    pictogramUrl: '../../../../assets-proxy/animations/burger.svg',
    backgroundColor: '#ffb146',
    fontColor: '#000000',
    restaurantLibelle: 'Wonderfood',
    showPeriode: true,
  },
  {
    title: 'Fast & Bio',
    description: 'Un ensemble de spécialités bio vous sera proposé au sein de votre restaurant. Vous pourrez les déguster sous forme de buffet.',
    shortDescription: 'Retrouvons-nous pour découvrir et profiter de la cuisine bio.',
    imageUrl: '../../../../assets-proxy/animations/animation2.jpeg',
    pictogramUrl: undefined,
    backgroundColor: undefined,
    fontColor: undefined,
    restaurantLibelle: "L'escale",
    showPeriode: true,
  },

  {
    title: 'Les 5 sens dans tous les sens',
    description: 'Un ensemble de spécialités gustatives vous sera proposé au sein de votre restaurant. Vous pourrez les déguster sous forme de buffet.',
    shortDescription: 'Retrouvons-nous pour découvrir de nouvelles sensations.',
    imageUrl: '../../../../assets-proxy/animations/animation3.jpg',
    pictogramUrl: '../../../../assets-proxy/animations/earth.svg',
    backgroundColor: '#FDE4BC',
    fontColor: '#000000',
    restaurantLibelle: 'La Cucina',
    showPeriode: true,
  },

  {
    title: "Faites un ch'ti tour du côté du nord ! Venez découvrir nos spécialités de la rue",
    description: 'Un ensemble de spécialités du nord vous sera proposé au sein de votre restaurant. Vous pourrez les déguster sous forme de buffet.',
    shortDescription: 'Retrouvons-nous pour découvrir les spécialités du nord',
    imageUrl: '../../../../assets-proxy/animations/animation4.jpg',
    pictogramUrl: '../../../../assets-proxy/animations/restaurant.svg',
    backgroundColor: '#D1918F',
    fontColor: '#000000',
    restaurantLibelle: 'Restaurant administratif de Périgueux',
    showPeriode: false,
  },
];

function createAnimations() {
  const today = new Date();
  const animations: RestaurantAnimationDto[] = [];
  for (let i = 0; i < 13; i++) {
    const props = PROPS[i % 4];
    animations.push(
      createAnimation(
        props.title,
        props.description,
        props.shortDescription,
        props.imageUrl,
        props.pictogramUrl,
        props.backgroundColor,
        props.fontColor,
        props.restaurantLibelle,
        addDays(today, i),
        addDays(today, i + (i % 2 === 0 ? 3 : 0)),
        i,
        props.showPeriode,
      ),
    );
  }
  return animations;
}

export const MOCK_ANIMATIONS_OK_PAGE0: GetAnimationsResult = {
  hasMore: true,
  animations: createAnimations().slice(0, 9),
};

export const MOCK_ANIMATIONS_OK_PAGE1: GetAnimationsResult = {
  hasMore: false,
  animations: createAnimations().slice(10, 12),
};

function translateAnimationsToEng(fr: GetAnimationsResult): GetAnimationsResult {
  return { ...fr, animations: [...fr.animations.map((a) => ({ ...a, title: 'ENG:' + a.title }))] };
}

export const MOCK_ANIMATIONS = {
  OK_PAGE0_FR: MOCK_ANIMATIONS_OK_PAGE0,
  OK_PAGE0_ENG: translateAnimationsToEng(MOCK_ANIMATIONS_OK_PAGE0),
  OK_PAGE1: MOCK_ANIMATIONS_OK_PAGE1,
  KO: getErrorResponse(AppErrorKeys.AnErrorOccured),
};
